<template>
  <v-dialog v-model="dialog" max-width="900px">
    <v-card>
      <v-card-title class="headline"> Результат загрузки </v-card-title>

      <v-card-text>
        <template v-if="type === 'avito'">
          <!-- Общая информация -->
          <div class="mb-3">
            <div><b>ID объявления:</b> {{ data.ad_id }}</div>
            <div><b>Avito ID:</b> {{ data.avito_id }}</div>
            <div>
              <b>Статус:</b>
              <v-chip small :color="statusColor" dark>
                {{ data.avito_status || "Ошибка" }}
              </v-chip>
            </div>
            <div><b>Раздел:</b> {{ data.section.title }}</div>
            <div v-if="data.url">
              <b>Ссылка:</b>
              <a :href="data.url" target="_blank">Открыть</a>
            </div>
            <div><b>Активно до:</b> {{ formatDate(data.avito_date_end) }}</div>
          </div>

          <v-divider class="my-3"></v-divider>

          <!-- Сообщения -->
          <div>
            <div class="mb-2"><b>Сообщения:</b></div>

            <v-alert
              v-for="(msg, index) in sortedMessages"
              :key="index"
              :type="mapType(msg.type)"
              dense
              outlined
              class="mb-2 custom-alert"
              :icon="false"
              @click="handleClick"
            >
              <v-icon small class="alert-icon" @click="onMessageClick(msg)">
                {{ getIcon(msg.type) }}
              </v-icon>

              <div v-if="msg.title">
                <b v-html="msg.title"></b>
              </div>

              <div v-if="msg.description" v-html="msg.description"></div>

              <div class="text-caption grey--text">
                {{ formatDate(msg.updated_at) }}
              </div>
            </v-alert>
          </div>
        </template>
        <template v-else-if="type === 'cian'">
          <div><b>Offer ID:</b> {{ data.offerId }}</div>
          <div><b>External ID:</b> {{ data.externalId }}</div>

          <div>
            <b>Статус:</b>
            <v-chip small :color="cianStatusColor" dark>
              {{ data.status }}
            </v-chip>
          </div>

          <div>
            <b>Ссылка:</b>
            <a :href="data.url" target="_blank">Открыть</a>
          </div>

          <v-divider class="my-3"></v-divider>

          <!-- Ошибки -->
          <div v-if="data.errors?.length">
            <b>Ошибки:</b>
            <v-alert v-for="(err, i) in data.errors" :key="'e' + i" type="error" dense outlined class="mb-2">
              {{ err }}
            </v-alert>
          </div>

          <!-- Предупреждения -->
          <div v-if="data.warnings?.length">
            <b>Предупреждения:</b>
            <v-alert v-for="(warn, i) in data.warnings" :key="'w' + i" type="warning" dense outlined class="mb-2">
              {{ warn }}
            </v-alert>
          </div>

          <!-- Если всё чисто -->
          <v-alert v-if="!data.errors?.length && !data.warnings?.length" type="success" dense outlined> Без ошибок и предупреждений </v-alert>
        </template>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="dialog = false">Закрыть</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  components: {},

  data() {
    return {
      dialog: false,
      data: {}, // сюда кладешь ответ от API
      type: "",

      // тестовые данные
      avitoResponse: {},
      cianResponse: {},
    };
  },
  computed: {
    sortedMessages() {
      if (!this.data?.messages) return [];

      return [...this.data.messages].sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));
    },
    statusColor() {
      switch (this.data.avito_status || "error") {
        case "active":
          return "green";
        case "inactive":
          return "grey";
        case "error":
          return "red";
        default:
          return "blue";
      }
    },
    cianStatusColor() {
      switch (this.data.status) {
        case "Published":
          return "green";
        case "Draft":
          return "grey";
        case "Error":
          return "red";
        default:
          return "blue";
      }
    },
  },
  watch: {},
  methods: {
    handleClick(e) {
      const link = e.target.closest("a");
      if (link) {
        e.preventDefault();
        window.open(link.href, "_blank");
      }
    },
    onMessageClick(msg) {
      console.log({ msg, data: this.data });
    },
    openDialog(response) {
      this.data = response;
      this.dialog = true;
    },
    openAvito(res) {
      this.type = "avito";
      this.data = res;
      this.dialog = true;
    },

    openCian(res) {
      this.type = "cian";
      this.data = res;
      this.dialog = true;
    },
    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleString();
    },
    mapType(type) {
      switch (type) {
        case "warning":
          return "warning";
        case "alarm":
          return "warning";
        case "error":
          return "error";
        case "info":
          return "info";
        default:
          return "info";
      }
    },
    getIcon(type) {
      if (type === "error") return "mdi-alert-circle";
      if (type === "warning") return "mdi-alert";
      return "mdi-information";
    },
  },
};
</script>

<style scoped>
.custom-alert {
  overflow: hidden; /* важно для float */
}

.custom-alert .alert-icon {
  float: left;
  margin-right: 8px;
  margin-top: 2px;
}
</style>
